import { mapGetters } from 'vuex';
import videos from '@/components/support/videos/videos.vue';


export default {
  components: {
    videos,
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    showVideos() {
      return !this.isLayoutMobile && !this.isLoggedIn;
    },
    mainColumnModifiers() {
      return {
        column: true,
        'small-12': true,
        'large-8': this.showVideos,
      };
    },
    mainRowModifiers() {
      return {
        row: !this.showVideos,
        'row-x': this.showVideos,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/support.js